import { render, staticRenderFns } from "./FileForm13.vue?vue&type=template&id=4dd19fe4&scoped=true&"
import script from "./FileForm13.vue?vue&type=script&lang=js&"
export * from "./FileForm13.vue?vue&type=script&lang=js&"
import style0 from "./FileForm13.vue?vue&type=style&index=0&id=4dd19fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd19fe4",
  null
  
)

export default component.exports